import { Ruler } from 'lucide-react';
import AnnotationToolbarEntry from '~/components/toolbar/shared/AnnotationToolbarEntry';
import MeasurementPanel from './MeasurementPanel';

const WINDOW_WIDTH = 280;

/**
 * Toolbar entry for the image measurement tool. The panel stays open while
 * the tool is selected so new measurements can be started and existing ones
 * managed without switching tools; closing it exits the tool. Committed
 * measurements keep rendering on the image afterwards and are removed only
 * via the panel's per-row delete or "Clear all".
 */
export default function MeasurementTool() {
    return (
        <AnnotationToolbarEntry
            tool="measurement"
            icon={<Ruler />}
            tooltipId="measurement.tooltip"
            titleId="measurement.title"
            testId="measurement-tool-button"
            width={WINDOW_WIDTH}
        >
            <MeasurementPanel />
        </AnnotationToolbarEntry>
    );
}
